export const DeviceCardTestIds = {
  deviceCard: 'deviceCard',
  deviceCardHeader: 'deviceCard_header',
  deviceCardHeaderInput: 'deviceCard_header_input',
  deviceCardHeaderName: 'deviceCard_header_name',
  deviceCardBody1: 'deviceCard_body1',
  deviceCardBody1IpValue: 'deviceCard_body1_ipValue',
  deviceCardBody1DeviceIdValue: 'deviceCard_body1_deviceIdValue',
  dividerTitle: 'divider_title',
  deviceCardBody2: 'deviceCard_body2',
  deviceCardBody2LastSeenValue: 'deviceCard_body2_lastSeenValue',
  deviceCardButtonDelete: 'deviceCard_button_delete',
  deviceCardButtonEdit: 'deviceCard_button_edit',
  deviceCardButtonCancel: 'deviceCard_button_cancel',
  deviceCardButtonSave: 'deviceCard_button_save'
} as const;
